import { Pipe, PipeTransform } from '@angular/core';
import { BrandingService } from '../../core/services/branding.service';

@Pipe({
  name: 'brandAsset',
  pure: false,
})
export class BrandAssetPipe implements PipeTransform {
  constructor(private brandingService: BrandingService) {}

  transform(path: string | null | undefined): string | null | undefined {
    if (!path) {
      return path;
    }

    return this.brandingService.getAssetPath(path);
  }
}
